




























import { Vue, Component, Prop } from "vue-property-decorator";
import { InvoiceListEntry } from "../../models/invoice-list-entry";

@Component
export default class InvoiceListTable extends Vue {
  // feature flag determinations (reactive)
  private shouldShowVsValueForCustomer: boolean = this.$launchDarkly.variation(
    "show-vs-value-for-customer",
    false
  );

  @Prop() selectedInvoice!: InvoiceListEntry;

  isFailed(m: string | number) {
    return m === 0 || m === "0";
  }
}
